import React from 'react';
import { Helmet } from 'react-helmet';

const roadmapData = [
  { date: "November 2024", description: "🎉 SMS Textr goes live, allowing users to send SMS across the USA & Canada.", completed: true },
  { date: "January 2025", description: "🌍 Expanded SMS coverage to India, Germany, UK, Thailand, Australia, Spain, Portugal, Italy, and Poland.", completed: true },
  { date: "February 2025", description: "📡 Added SMS support for Denmark, Ireland, and Luxembourg.", completed: true },
  { date: "March 2025", description: "💬 Introduced Receiving SMS capabilities, enabling businesses to get replies.", completed: true },
  { date: "May 2025", description: "🔒 OTP Verification Service – SMS Textr introduces OTP service for seamless and secure user verification for your applications.", completed: true },
  { date: "June 2025", description: "📞 Unique phone numbers for businesses, allowing dedicated SMS communication.", completed: false },
  { date: "September 2025", description: "⚡ Faster SMS delivery and improved API response times for better efficiency.", completed: false },
  { date: "November 2025", description: "📸 MMS capabilities added – Send multimedia messages including images & videos.", completed: false },
  { date: "December 2025", description: "🚀 Expanding to 30+ countries, making SMS Textr a truly global platform.", completed: false }
];

const AboutUsPage = () => {
  return (
    <div style={containerStyle}>
      <Helmet>
        <title>About Us | SMS Textr</title>
        <meta name="description" content="Learn about SMS Textr, a pay-as-you-go SMS API platform that enables businesses and developers to send SMS messages seamlessly." />
        <meta name="keywords" content="About SMS Textr, SMS API service, affordable SMS API, SMS for developers, SMS for business, pay-as-you-go SMS, no subscription SMS, SMS messaging API, SMS service provider, bulk SMS service, North America SMS API" />
        <meta name="author" content="SMS Textr Team" />
      </Helmet>

      <section style={aboutSectionStyle}>
        <h1>About Us</h1>
      </section>

      <section style={contentSectionStyle}>
        <p>
          At <strong>SMS Textr</strong>, we’re transforming how businesses and developers connect with their customers.
          We know that in today’s fast-paced world, communication should be instant, affordable, and reliable—
          and that’s why we designed SMS Textr to empower you with seamless messaging, without the constraints of subscriptions or complex setups.
        </p>
        <p>
          Our platform offers a pay-as-you-go SMS API that’s flexible, powerful, and ready to integrate into your existing systems in minutes.
          By stripping away unnecessary barriers, we enable businesses of all sizes to focus on innovation and customer engagement.
        </p>
        <p>
          Whether you’re looking to send alerts, engage customers, or enhance your app’s functionality, SMS Textr is designed to grow with you.
          Join us in reshaping the way businesses communicate—one message at a time.
        </p>
      </section>

      {/* Roadmap Section */}
      <section style={roadmapSectionStyle}>
        <h2>📍 Our Roadmap</h2>
        <div style={timelineContainerStyle}>
          {roadmapData.map((milestone, index) => (
            <div key={index} style={timelineItemStyle}>
              <div style={timelineDateStyle}>{milestone.date}</div>
              <div style={timelineContentStyle}>
                {milestone.description}
                {milestone.completed && <span style={checkMarkStyle}> ✅</span>}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Privacy & Terms Links */}
      <div style={{ marginTop: '20px' }}>
        <a href="/privacy" style={{ fontSize: '12px', color: '#007BFF' }}>Privacy Policy</a> {' | '}
        <a href="/tos" style={{ fontSize: '12px', color: '#007BFF' }}>Terms of Service</a>
      </div>
    </div>
  );
};

// Inline CSS Styles
const containerStyle = {
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
};

const aboutSectionStyle = {
  marginBottom: '30px',
};

const contentSectionStyle = {
  backgroundColor: '#f9f9f9',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
};

const roadmapSectionStyle = {
  marginTop: '40px',
  backgroundColor: '#fff',
  padding: '30px',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
};

const timelineContainerStyle = {
  position: 'relative',
  paddingLeft: '20px',
  borderLeft: '3px solid #4CAF50',
  marginTop: '20px',
};

const timelineItemStyle = {
  position: 'relative',
  marginBottom: '20px',
  paddingLeft: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const timelineDateStyle = {
  fontWeight: 'bold',
  color: '#4CAF50',
};

const timelineContentStyle = {
  background: '#f9f9f9',
  padding: '10px',
  borderRadius: '5px',
  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
  flexGrow: 1, // Ensures content stretches and checkmark stays right-aligned
};

const checkMarkStyle = {
  fontSize: '24px',
  color: '#4CAF50',
  marginLeft: '10px',
};

export default AboutUsPage;
